/**
 * Avatar — supports both numeric pixel sizes (legacy) and named string sizes
 * ('sm', 'md', 'lg') used throughout features/work-projects.
 */
const COLORS = [
  '#0052CC',
  '#00875A',
  '#6554C0',
  '#DE350B',
  '#FF991F',
  '#00A3BF',
  '#403294',
];

function colorFor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) % COLORS.length;
  return COLORS[hash];
}

function initials(name: string): string {
  return name
    .split(' ')
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

const SIZE_MAP: Record<string, number> = { sm: 24, md: 32, lg: 40 };

interface AvatarProps {
  name: string;
  /** Named size ('sm' | 'md' | 'lg') or explicit pixel number. Defaults to 24. */
  size?: 'sm' | 'md' | 'lg' | number;
  ring?: boolean;
  className?: string;
}

export function Avatar({ name, size = 24, ring, className }: AvatarProps) {
  const px = typeof size === 'number' ? size : (SIZE_MAP[size] ?? 24);
  return (
    <span
      title={name}
      className={`inline-flex shrink-0 items-center justify-center rounded-full font-bold text-white select-none transition-shadow duration-150 ${
        ring ? 'ring-2 ring-white shadow-xs' : ''
      } ${className ?? ''}`}
      style={{
        backgroundColor: colorFor(name),
        width: px,
        height: px,
        fontSize: Math.max(9, Math.floor(px * 0.42)),
      }}
    >
      {initials(name)}
    </span>
  );
}
